module.exports = __webpack_public_path__ + "static/media/clubs-king.ae6cca60.png";